import noOrders from "@/assets/myaccount/noOrders.svg";
import { Button } from "@/components/ui/button";
import Cookies from "universal-cookie";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
// import { MdEdit, MdDelete } from "react-icons/md";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  archiveUser,
  createUser,
  fetchGroups,
  fetchLicenses,
  fetchOrgUser,
  unarchiveUser,
} from "../services/organizationServices";
import { useLoading } from "@/contexts/LoadingContext";
import greenInfoIcon from "@/assets/myaccount/greenInfoIcon1.svg";
import redLicenseIcon from "@/assets/myaccount/used.svg";
import blueLicenseIcon from "@/assets/myaccount/total.svg";
import greenLicenseIcon from "@/assets/myaccount/left.svg";

import lock from "@/assets/myaccount/lock.svg";
import useDebounce from "@/hooks/useDebounce";
import { IoSearch } from "react-icons/io5";
// import ArchiveIcon from "@/assets/myaccount/archive.svg";
import EditIcon from "@/assets/myaccount/edit.svg";
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "@/components/ui/tooltip";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
// import { GiStarPupil } from "react-icons/gi";
// import { Eye, EyeOff } from "lucide-react";
import EditUserDialog from "./EditUser";
import toastService from "@/services/toastService";
import archiveChip from "@/assets/myaccount/organisation-users/chip.svg";
import archiveIcon from "@/assets/myaccount/organisation-users/archive.svg";
import unarchiveIcon from "@/assets/myaccount/organisation-users/un-archive.svg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";

// import {ArchiveIcon } from "lucide-react";

export interface PaymentDetails {
  provider: string;
  productId: string;
  subscriptionId: string;
}

export interface CreationDetails {
  paymentDetails: PaymentDetails;
}

export interface SubscriptionDetails {
  id: number;
  name: string;
  display_name: string;
  stripe_product_id: string;
}

export interface SubUser {
  _id: string;
  email: string;
  status: number;
  creationDetails: CreationDetails;
  fullName: string;
  pgCustomerId: string;
  subscriptionDetails: SubscriptionDetails;
}

export interface License {
  id: string;
  name: string;
  product_id?: string;
  quantity?: number;
  show_group_ids_dropdown?: boolean;
}

export interface Group {
  group_id: number;
  group_name: string;
}

export interface AppGroups {
  app_name: string;
  groups: Group[];
}
interface PaginationData {
  page: number;
  limit: number;
  nextPage: number;
}

const OrganizationUsers = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [subUsers, setSubUsers] = useState<SubUser[]>([]);
  const [licenses, setLicenses] = useState<License[]>([]);
  const debouncedSearchTerm = useDebounce(searchTerm);
  const [selectedLicense, setSelectedLicense] = useState<License | null>(null);

  const [remainingCount, setRemainingCount] = useState<number>(0);
  const [totalCount, settotalCount] = useState<number>(0);
  const [usedCount, setusedCount] = useState<number>(0);
  const { setLoading } = useLoading();
  // Multi Select state
  const [appGroups, setAppGroups] = useState<{ [key: string]: Group[] }>({});

  const [selectedGroups, setSelectedGroups] = useState<
    Record<string, string | undefined>
  >({});
  const [selectedApps, setSelectedApps] = useState<string[]>([]);

  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [productId, setProductId] = useState("");
  // const [showPassword, setShowPassword] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [pagination, setPagination] = useState<PaginationData>({
    page: 1,
    limit: 10,
    nextPage: -1,
  });

  console.log(isDropdownOpen, "--isDropdownOpen");
  const navigate = useNavigate();

  // edit user details related actions
  const [selectedUser, setSelectedUser] = useState<SubUser | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isArchivedDialog, setIsArchivedDialog] = useState(false);
  const [isUnArchivedDialog, setIsUnArchivedDialog] = useState(false);
  // const [unarchiveOptions, setUnarchiveOptions] = useState<
  //   { id: string; name: string; quantity: number; show_group_ids_dropdown:boolean; }[]
  // >([]);
  // const [selectedOption, setSelectedOption] = useState<string>("");
  // const [bmpUserId, setBmpUserId] = useState<string>("")

  console.log(selectedUser, "line 131");
  console.log(licenses, "line 136");

  // const handleEditUser = (user) => {
  //   console.log(user,"line 134")
  //   setSelectedUser(user);
  //   setIsEditDialogOpen(true);
  // };

  // const [userDetails, setUserDetails] = useState({
  //   name: "",
  //   phone: "",
  //   email: "",
  //   password: "",
  //   license: "",
  // });

  useEffect(() => {
    if (isUnArchivedDialog) {
      fetchLicensesList();
    }
  }, [isUnArchivedDialog]);

      const cookies = new Cookies();
      useEffect(() => {
        const checkAuth = () => {
          const authCookie = cookies.get("isAuthenticated");
          // const isAuth = authCookie === "true";
          console.log("values of authCookie", authCookie);
          setIsAuthenticated(authCookie);
        };
    
        checkAuth();
      }, []);

  const handleUnArchiveDialogClose = () => {
      fetchUsersList();
    setSelectedApps([]);
    setSelectedGroups({});
    setContactName("");
    setContactEmail("")
    // setPassword("")
    setSelectedLicense(null)
    
    setIsUnArchivedDialog(false);
    // setSelectedOption("");
  
    // fetchLicensesList();
 
    
  };



  const handleSubmitUnarchive = async (data: { bmp_user_id: string }) => {
  setLoading(true);

  try {
    if (!selectedLicense) {
      toastService.error("Please select a license.");
      return;
    }

    const productId :string = selectedLicense.product_id!;
    setProductId(productId || "");

    const groupIds: number[] = Object.values(selectedGroups)
      .filter(Boolean)
      .map((id) => Number(id));

    console.log("Unarchiving with:", {
      productId,
      bmp_user_id: data.bmp_user_id,
      groupIds,
    });

    const response = await unarchiveUser(data.bmp_user_id, productId, groupIds);
    console.log("Unarchive response:", response);

    if (response?.statusCode === 200) {
      toastService.success("User Unarchived successfully");
      handleUnArchiveDialogClose();
      fetchLicensesList();
    }
  } catch (error: any) {
    console.log("Error unarchiving user:", error);
    // toastService.error(error?.message || "An unexpected error occurred");
  } finally {
    setLoading(false);
  }
};


  // edit user details related actions
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Clear selected apps and groups when license changes
    setSelectedApps([]);
    setSelectedGroups({});
  }, [selectedLicense]);

  const handleCreateUser = async () => {
    if (!contactName || !contactEmail || !selectedLicense) {
      alert("Please fill all required fields");
      return;
    }
    console.log(selectedLicense, "----selectedLicense");
    // let password ='';

    const userData = {
      name: contactName,
      email: contactEmail,
      product_id: productId,
      group_ids: Object.values(selectedGroups)
        .map((v) => (v ? +v : undefined))
        .filter((v) => !!v) as number[],
      password: "App@@123",
    };

    console.log(userData, "line 185");

    await createSubUser(userData);
    // handleDialogClose(); // Close dialog after submission
  };

  const fetchUsersList = useCallback(
    async (query = "", page = pagination.page) => {
      setLoading(true);
      try {
        const response = await fetchOrgUser({
          page,
          limit: pagination.limit,
          q: query,
        });
        console.log(response?.data?.subUsers, "fetch sub user");
        setSubUsers(response?.data?.subUsers ?? []);
        setPagination((prev) => ({
          ...prev,
          page,
          nextPage: response?.data?.nextPage || -1,
        }));
      } catch (err) {
        console.error("Error fetching users:", err);
        setSubUsers([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, pagination.limit]
  );

  const fetchLicensesList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchLicenses();
      console.log(response?.data?.availableLicenses, "line 86");
      setLicenses(response?.data?.availableLicenses ?? []);
      setRemainingCount(response?.data?.availableSubUserLicenseCount);
      setusedCount(response?.data?.usedSubUserLicenseCount);
      settotalCount(response?.data?.subUserLicenseCount);
      // setUnarchiveOptions(response?.data?.availableLicenses ?? []);
      // await fetchGroupsList(response?.data?.availableLicenses?.product_id)
    } catch (err) {
      console.error("Error fetching licenses:", err);
      setLicenses([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const fetchGroupsList = useCallback(
    async (product_id: string) => {
      setLoading(true);
      try {
        const response = await fetchGroups({ product_id });
        const formattedGroups = response?.data?.groups.reduce(
          (acc: { [key: string]: Group[] }, app: AppGroups) => {
            acc[app.app_name] = app.groups;
            return acc;
          },
          {}
        );
        setAppGroups(formattedGroups || {});
      } catch (err) {
        console.error("Error fetching groups:", err);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const createSubUser = useCallback(
    async (data: {
      name: string;
      email?: string;
      product_id?: string;
      group_ids: Array<number>;
      password: string;
    }) => {
      setLoading(true);
      try {
        console.log(data, "line 154");
        const response = await createUser(data);
        console.log(response?.data, "fetch sub user");
        console.log(response, "response");
        if (response.statusCode === 201) {
          toastService.success("Sub user created successfully");
        }
        setIsDialogOpen(false);
        handleDialogClose();

        await fetchLicensesList();
        await fetchUsersList();
        // setSubUsers(response?.data?.subUsers ?? []);
      } catch (err) {
        console.error("Error fetching users:", err);
        setSubUsers([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const handleLicenseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;

    // Find the selected license by its product_id or name
    const selectedLicenseObj = licenses.find(
      (license) => license.product_id === selectedId // <-- assuming product_id is in select's value
    );

    console.log(selectedLicenseObj, "line 154");

    setSelectedLicense(selectedLicenseObj ?? null); // <-- store the full object

    const productId = selectedLicenseObj?.product_id ?? "";
    setProductId(productId);

    if (productId && selectedLicenseObj?.show_group_ids_dropdown) {
      fetchGroupsList(productId);
    }
  };

  const toggleAppSelection = (appName: string) => {
    if (!selectedApps.includes(appName)) {
      setSelectedApps((prev) => [...prev, appName]);
      const group = appGroups[appName];
      setSelectedGroups((prev) => ({
        ...prev,
        [appName]: String(group[group.length - 1].group_id), // Ensure you access the correct property
      }));
    } else {
      setSelectedApps((prev) => prev.filter((a) => a !== appName));
      setSelectedGroups((prev) => ({
        ...prev,
        [appName]: undefined, // Ensure you access the correct property
      }));
    }
  };

  const toggleGroupSelection = (groupId: string, appName: string) => {
    setSelectedGroups((prev) => ({
      ...prev,
      [appName]: groupId, // Using dynamic key assignment for appName
    }));

    console.log("selected groups", selectedGroups, selectedApps);
  };

  const handleDialogClose = () => {
    setSelectedApps([]);
    setSelectedGroups({});
    setContactName("");
    setContactEmail("");
    // setPassword("")
    setSelectedLicense(null);
  };

  useEffect(() => {
    if (!isDialogOpen) handleDialogClose();
  }, [isDialogOpen]);

  useEffect(() => {
    console.log("isAuthenticated", isAuthenticated);
    if(isAuthenticated) {
    fetchUsersList(debouncedSearchTerm, 1);
    fetchLicensesList();
    }
    // fetchGroupsList();
  }, [debouncedSearchTerm, fetchUsersList, fetchLicensesList, fetchGroupsList,isAuthenticated]);

const updateOnEdit = async () => {
  await fetchUsersList();
};


const filteredUsers = useMemo(() => {
  return subUsers.filter((user) =>
    user.fullName.toLowerCase().includes(searchTerm.toLowerCase())
  );
}, [subUsers, searchTerm]);


  const archiveSubUser = useCallback(
    async (data: { bmp_user_id: string }) => {
      setLoading(true);
      try {
        console.log(data, "line 154");
        const response = await archiveUser(data);
        console.log(response?.data, "fetch sub user");
        if (response.message == 200) {
          toastService.success("User archived successfully");
        }
        await fetchUsersList();
        await fetchLicensesList();
        // setSubUsers(response?.data?.subUsers ?? []);
      } catch (err) {
        console.error("Error fetching users:", err);
        setSubUsers([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );
  const handlePageChange = (newPage: number) => {
    if (
      newPage >= 1 &&
      (newPage < pagination.page || pagination.nextPage !== -1)
    ) {
      fetchUsersList(debouncedSearchTerm, newPage);
    }
  };
  const isFormValid =
    contactName.trim() !== "" &&
    contactEmail.trim() !== "" &&
    selectedLicense !== null &&
    (!selectedLicense?.show_group_ids_dropdown ||
      (selectedApps.length > 0 &&
        selectedApps.every((app) => selectedGroups[app])));

  return (
    <div className="h-full p-4 mt-0">
      {!totalCount ? (
        <div className="flex flex-col items-center justify-center text-center pt-16 px-4 ">
          <img src={noOrders} alt="No Users" className="w-48 h-48 mt-10" />

          <p className="text-gray-500 text-[24px]">
            You have no organization user
          </p>

          <div className="bg-[#28af4a]/20 p-2   items-start rounded-md my-6">
            <p className="text-[#28af4a] text-[18px] font-medium text-start px-4 flex items-center">
              <div className="flex  gap-x-1 text-[#28af4a]">
                <img src={lock} className="w-5 h-5"></img>
                You need an active subscription before you can add team members.
              </div>
            </p>
          </div>

          <Button
            size="sm"
            variant="outline"
            className="bg-[#181818] text-white px-4"
            onClick={() => navigate("/profile/subscription")}
          >
            Go to Subscription
          </Button>
        </div>
      ) : subUsers.length === 0 && !debouncedSearchTerm ? (
        <div className="flex flex-col items-center justify-center text-center pt-16 px-4 ">
          <img src={noOrders} alt="No Users" className="w-48 h-48 mt-10" />

          <p className="text-gray-500 text-base">
            Manage your organization's sub-users here.
          </p>

          <div className="bg-[#28af4a]/20 p-2 2xl:w-[50%] w-[70%] space-y-2 items-start rounded-md my-6">
            <p className="text-[#28af4a] text-[18px] font-medium text-start px-4 flex items-center">
              <img
                src={greenInfoIcon}
                className="size-[16px] flex-shrink-0 mr-2"
                alt="info"
              />
              <span>
                You’ve got active subscriptions — now it’s time to make the most
                of them!
              </span>
            </p>
            <p className="text-[#28af4a] text-[18px] font-medium text-start px-4 flex items-start">
              <img
                src={greenInfoIcon}
                className="size-[16px] flex-shrink-0 mr-2 mt-1"
                alt="info"
              />
              <span className="flex-1">
                Add sub-users and assign licenses to your team so they can start
                using BuildMapper too.
              </span>
            </p>
          </div>

          <Button
            size="sm"
            variant="outline"
            className="bg-[#181818] text-white px-4"
            onClick={() => setIsDialogOpen(true)}
          >
            Add New User
          </Button>
        </div>
      ) : (
        <>
          <div className="flex gap-x-4 h-[40px] justify-between">
            <fieldset className="relative w-[23vw] h-full ">
              <Button
                variant="ghost"
                size="sm"
                className="absolute left-2 top-1/2 transform -translate-y-1/2"
              >
                <IoSearch size={15} />
              </Button>
              <Input
                type="text"
                placeholder="Search "
                className="w-full h-full pl-10 pr-4 py-2 border rounded text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </fieldset>
            <Button
              size="sm"
              variant="outline"
              className="bg-[#181818] text-white px-4 h-[40px]"
              onClick={() => setIsDialogOpen(true)}
            >
              Add New User
            </Button>
          </div>

          <div className="mt-4">
            <div className="grid  sm:grid-cols-3 2xl:gap-10 gap-4 w-full">
              {/* Total Licenses */}
              <div className="bg-[#f4f8ff] flex justify-between items-center p-4 rounded-xl">
                <div>
                  <p className="text-[20px] font-medium text-[#181818]">
                    Total Licenses
                  </p>
                  <div className="flex items-center gap-x-2">
                    <p className="text-[40px] font-bold text-[#181818] leading-8 mt-4">
                      {" "}
                      {totalCount === 0
                        ? "--"
                        : totalCount < 10
                          ? `0${totalCount}`
                          : totalCount}
                    </p>
                    <Button
                      size="sm"
                      variant="outline"
                      className=" text-[#72a1e0] text-[13px] font-medium px-4 mt-2 hover:text-blue-600 border-[#72a1e0] bg-[#f4f8ff]"
                      onClick={() => navigate("/profile/subscription")}
                    >
                      Add License
                    </Button>
                  </div>
                </div>
                <img
                  src={blueLicenseIcon}
                  alt="Total Licenses"
                  className="w-12 h-12"
                />
              </div>

              {/* Total Used Licenses */}
              <div className="bg-[#fff1f1] flex justify-between items-center p-4 rounded-xl">
                <div>
                  <p className="text-[20px] font-medium text-[#181818]">
                    Total Used Licenses
                  </p>
                  <p className="text-[40px] font-bold text-[#181818] leading-8 mt-4 ">
                    {usedCount === 0
                      ? "--"
                      : usedCount < 10
                        ? `0${usedCount}`
                        : usedCount}
                  </p>
                </div>
                <img
                  src={redLicenseIcon}
                  alt="Used Licenses"
                  className="w-12 h-12"
                />
              </div>

              {/* Licenses Left */}
              <div className="bg-[#ecfdf4] flex justify-between items-center p-4 rounded-xl">
                <div>
                  <p className="text-[20px] font-medium text-[#181818]">
                    Licenses Left
                  </p>
                  <p className="text-[40px] font-bold text-[#181818] leading-8 mt-4">
                    {remainingCount === 0
                      ? "--"
                      : remainingCount < 10
                        ? `0${remainingCount}`
                        : remainingCount}
                  </p>
                </div>
                <img
                  src={greenLicenseIcon}
                  alt="Licenses Left"
                  className="w-12 h-12"
                />
              </div>
            </div>

            {filteredUsers.length === 0 ? (
              <div className="flex justify-center items-center h-64">
                <p className="text-gray-500 text-lg">No Users Exist</p>
              </div>
            ) : (
              <Table className="mt-4">
                <TableHeader className="bg-slate-100 rounded-tl-lg rounded-tr-lg">
                  <TableRow>
                    <TableHead className="pl-19 text-black text-left rounded-tl-lg">
                      Name
                    </TableHead>
                    <TableHead className="p-3 text-black text-left">
                      Email
                    </TableHead>
                    <TableHead className="p-3 text-black text-left">
                      License
                    </TableHead>
                    <TableHead className="p-3 text-black text-left rounded-tr-lg">
                      Actions
                    </TableHead>
                  </TableRow>
                </TableHeader>

                <TableBody className="border rounded-md">
                  {filteredUsers.map((user) => (
                    <TableRow key={user._id}>
                      <TableCell className="p-3 text-left text-base">
                        <div className="flex items-center gap-x-2">
                          <span>{user.fullName}</span>
                          {user.status === 4 && (
                            <img
                              src={archiveChip}
                              alt="Archived"
                              className="h-6 w-auto"
                            />
                          )}
                        </div>
                      </TableCell>

                      <TableCell className="p-3 text-left text-base">
                        {user.email}
                      </TableCell>
                      <TableCell className="p-3 text-left text-base">
                        {user?.subscriptionDetails?.display_name || "-"}
                      </TableCell>

                      <TableCell className="p-3 flex justify-start space-x-4">
                        {/* Conditionally show the Edit Icon and Tooltip only if user.status is 1 */}
                        {user.status === 1 && (
                          <div className="relative group">
                            <Button
                              variant="secondary"
                              size="icon"
                              onClick={() => {
                                setSelectedUser(user);
                                setIsEditDialogOpen(true);
                              }}
                            >
                              <img
                                className="size-[30px]"
                                src={EditIcon} // Replace with actual edit icon path
                                alt="edit-icon"
                              />
                            </Button>

                            {/* Tooltip */}
                            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-800 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
                              Edit User
                              <span className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-gray-800 rotate-45 transform origin-center"></span>
                            </span>
                          </div>
                        )}

                        <div className="relative group">
                          {/* Show Archive Icon if user status is 1 */}
                          {user.status === 1 && (
                            <Button
                              variant="secondary"
                              size="icon"
                              // onClick={() =>

                              //   setIsArchivedDialog(true)} // This can trigger the archive/unarchive action
                              onClick={() => {
                                setSelectedUser(user);
                                setIsArchivedDialog(true);
                              }}
                            >
                              <img
                                className="size-[30px]"
                                src={archiveIcon} // Archive icon
                                alt="archive-icon"
                              />
                            </Button>
                          )}

                          {/* Show Unarchive Icon if user status is 4 */}
                          {user.status === 4 && (
                            <Button
                              variant="secondary"
                              size="icon"
                              // onClick={() => setIsUnArchivedDialog(true)} // Same dialog can be used to handle unarchiving
                              onClick={() => {
                                setSelectedUser(user);
                                setIsUnArchivedDialog(true);
                              }}
                            >
                              <img
                                className="size-[30px]"
                                src={unarchiveIcon} // Unarchive icon
                                alt="unarchive-icon"
                              />
                            </Button>
                          )}

                          {/* Tooltip */}
                          <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-800 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
                            {user.status === 1
                              ? "Archive User"
                              : "Unarchive User"}
                            <span className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-gray-800 rotate-45 transform origin-center"></span>
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableRow className="rounded-b-lg bg-slate-100">
                  <TableCell colSpan={5}>
                    <div className="flex justify-center items-center">
                      <div className="flex items-center space-x-4">
                        <Button
                          variant="outline"
                          disabled={pagination.page === 1}
                          onClick={() => handlePageChange(pagination.page - 1)}
                        >
                          <FaChevronLeft />
                        </Button>
                        <span className="text-gray-700 font-medium">
                          Page {pagination.page}
                        </span>
                        <Button
                          variant="outline"
                          disabled={pagination.nextPage === -1}
                          onClick={() => handlePageChange(pagination.page + 1)}
                        >
                          <FaChevronRight />
                        </Button>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              </Table>
            )}
          </div>
        </>
      )}

      <Dialog
        modal={false}
        open={isUnArchivedDialog}
        onOpenChange={(open) => {
          if (!open) handleUnArchiveDialogClose();
        }}
      >
        {isUnArchivedDialog && (
          <>
            <div className="fixed inset-0 z-50 bg-black/70" />
            <DialogContent className="max-w-[500px] p-0 flex flex-col  rounded-xl overflow-hidden bg-white ">
              <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4 ">
                <DialogTitle className="text-[22px">Unarchive User</DialogTitle>
              </DialogHeader>

              <div className=" p-4 space-y-4">
                {/* <label className="block mb-2 text-sm font-medium">Select Product</label> */}
                <p className=" text-[14px]">
                  {" "}
                  Please select a product to assign to this user.
                </p>
                <select
                  value={selectedLicense?.product_id ?? ""}
                  onChange={handleLicenseChange}
                  className="w-full p-2 border h-[50px] rounded-md"
                >
                  <option value="">Select a product</option>

                     {licenses.map((license) => (
                    <option
                      key={license.product_id}
                      value={license.product_id}
                      disabled={license.quantity === 0}
                    >
                      {license.name} (Quantity: {license.quantity})
                    </option>
                  ))}
                </select>
                  {selectedLicense?.show_group_ids_dropdown && (
                  <Popover>
                    <PopoverTrigger asChild>
                      <div className="p-3  border rounded-md bg-white cursor-pointer">
                        {selectedApps.length === 0 ? (
                          "Select Groups"
                        ) : (
                          <div className="flex flex-wrap gap-2">
                            {selectedApps.map((app) => {
                              const groupId = selectedGroups[app];
                              const group = appGroups[app]?.find(
                                (g) => String(g.group_id) === groupId
                              );
                              return (
                                <span
                                  key={app}
                                  className="bg-gray-100 px-2 py-1 rounded text-sm text-gray-800"
                                >
                                  {app}
                                  {group ? ` (${group.group_name})` : ""}
                                </span>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </PopoverTrigger>
                    <PopoverContent
                      className="w-80 z-[100]"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                      tabIndex={0}
                      asChild
                    >
                      <ScrollArea className="max-h-[200px] overflow-y-auto">
                        {Object.keys(appGroups).map((appName) => {
                          const appGroupList = appGroups[appName];
                          const lastGroup =
                            appGroupList[appGroupList.length - 1]; // Get the last group

                          return (
                            <div
                              key={appName}
                              className="mb-2"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <label className="flex cursor-pointer items-center space-x-2">
                                <Checkbox
                                  checked={selectedApps.includes(appName)}
                                  onCheckedChange={() => {
                                    toggleAppSelection(appName);
                                    if (
                                      !selectedApps.includes(appName) &&
                                      lastGroup
                                    ) {
                                      toggleGroupSelection(
                                        String(lastGroup.group_id),
                                        appName
                                      );
                                    }
                                  }}
                                />
                                <span className="font-semibold">{appName}</span>
                              </label>

                              {selectedApps.includes(appName) && (
                                <RadioGroup
                                  name={appName + "-radio-group"}
                                  value={selectedGroups[appName]} // Only one group can be selected
                                  onValueChange={(value) =>
                                    toggleGroupSelection(value, appName)
                                  }
                                >
                                  {appGroupList.map((group, ind) => (
                                    <div
                                      key={ind}
                                      className="ml-4 flex items-center space-x-2"
                                    >
                                      <RadioGroupItem
                                        id={String(group.group_id)}
                                        value={String(group.group_id)}
                                      />
                                      <label
                                        htmlFor={String(group.group_id)}
                                        className="!cursor-pointer"
                                      >
                                        {group.group_name}
                                      </label>
                                    </div>
                                  ))}
                                </RadioGroup>
                              )}
                            </div>
                          );
                        })}
                        <ScrollBar />
                      </ScrollArea>
                    </PopoverContent>
                  </Popover>
                )}
              </div>
              <hr></hr>

              <DialogFooter className="px-4 pb-6">
                <Button
                  variant="outline"
                  onClick={handleUnArchiveDialogClose}
                  className="h-[40px]"
                >
                  Cancel
                </Button>
                <Button
                  onClick={async () => {
                    // await handleSubmitUnarchive({ bmp_user_id: user._id });
                    await handleSubmitUnarchive({
                      bmp_user_id: selectedUser?._id ?? "",
                    });
                    handleUnArchiveDialogClose();
                  }}
                  disabled={
    !selectedLicense || 
    (selectedLicense?.show_group_ids_dropdown &&
      (selectedApps.length === 0 || selectedApps.some(app => !selectedGroups[app])))
  }
                   className="h-[40px] bg-[#181818] text-white disabled:bg-[#181818]/80"
                >
                  Confirm Unarchive
                </Button>
              </DialogFooter>
            </DialogContent>
          </>
        )}
      </Dialog>

      <Dialog
        modal={false}
        open={isArchivedDialog}
        onOpenChange={setIsArchivedDialog}
      >
        {isArchivedDialog && (
          <>
           <div className="fixed inset-0 z-50 bg-black/70" />
          <DialogContent hideCloseButton className="max-w-[500px] p-0 flex flex-col  rounded-xl overflow-hidden bg-white" >
            <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4 ">
              <DialogTitle className="text-lg">Archive User</DialogTitle>
            </DialogHeader>
            <DialogDescription className="p-4">
              This will revoke the user's access rights immediately. Are you
              sure you want to continue?
            </DialogDescription>

            <DialogFooter className="p-4">
              <Button
                variant="outline"
                onClick={() => setIsArchivedDialog(false)}
                className="h-[40px]"
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  // await archiveSubUser({ bmp_user_id: selectedUser?._id });
                  await archiveSubUser({
                    bmp_user_id: selectedUser?._id ?? "",
                  });
                  setIsArchivedDialog(false);
                }}
                className="h-[40px]"
              >
                Confirm Archive
              </Button>
            </DialogFooter>
          </DialogContent>
          </>
        )}
      </Dialog>

      <Dialog modal={false} open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        {isDialogOpen && (
          <section className="fixed inset-0 bg-black/70 z-[50]">
            <DialogContent className="max-w-2xl p-0 flex flex-col  rounded-xl overflow-hidden bg-white">
              <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4 ">
                <DialogTitle className="text-xl font-semibold text-gray-700">
                  Add New User
                </DialogTitle>
              </DialogHeader>

              <div className="grid grid-cols-2 gap-5  px-6 py-4 ">
                <Input
                  placeholder="Contact Name"
                  className="p-3 border rounded-md"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                />
                {/* <Input
                  placeholder="Enter Password"
                  className="p-3 border rounded-md"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                /> */}
                {/* <div className="relative w-full">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    className="p-3 border rounded-md w-full pr-10" // Extra right padding for icon
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div> */}
                <Input
                  placeholder="Enter Email"
                  className="p-3 border rounded-md"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                />

                <select
                  className="p-3 border rounded-md appearance-none bg-no-repeat bg-[length:1em_1em] pr-10 text-left"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3csvg fill='none' stroke='%23202b49' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'%3e%3c/path%3e%3c/svg%3e")`,
                    backgroundPosition: "right 0.75rem center",
                  }}
                  value={selectedLicense?.product_id ?? ""}
                  onChange={handleLicenseChange}
                >
                  <option value="" disabled>
                    Select License
                  </option>
                  {licenses.map((license) => (
                    <option
                      key={license.product_id}
                      value={license.product_id}
                      disabled={license.quantity === 0}
                    >
                      {license.name} (Quantity: {license.quantity})
                    </option>
                  ))}
                </select>

                {selectedLicense?.show_group_ids_dropdown && (
                  <Popover>
                    <PopoverTrigger asChild>
                      <div className="p-3 border flex justify-between items-center rounded-md bg-white cursor-pointer">
                        {selectedApps.length === 0 ? (
                          "Select Groups"
                        ) : (
                          <div className="flex flex-wrap gap-1">
                            {selectedApps.map((app) => {
                              const groupId = selectedGroups[app];
                              const group = appGroups[app]?.find(
                                (g) => String(g.group_id) === groupId
                              );
                              return (
                                <span
                                  key={app}
                                  className="bg-gray-100 px-2 py-1 rounded text-sm text-gray-800"
                                >
                                  {app}
                                  {group ? ` (${group.group_name})` : ""}
                                </span>
                              );
                            })}
                          </div>
                        )}
                         <ChevronDown className="ml-2 h-4 w-4 text-gray-500" />
                      </div>
                    </PopoverTrigger>
                    <PopoverContent
                      className="w-80 z-[100]"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                      tabIndex={0}
                      asChild
                    >
                      <ScrollArea className="max-h-[200px] overflow-y-auto">
                        {Object.keys(appGroups).map((appName) => {
                          const appGroupList = appGroups[appName];
                          const lastGroup =
                            appGroupList[appGroupList.length - 1]; // Get the last group

                          return (
                            <div
                              key={appName}
                              className="mb-2"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <label className="flex cursor-pointer items-center space-x-2">
                                <Checkbox
                                  checked={selectedApps.includes(appName)}
                                  onCheckedChange={() => {
                                    toggleAppSelection(appName);
                                    if (
                                      !selectedApps.includes(appName) &&
                                      lastGroup
                                    ) {
                                      toggleGroupSelection(
                                        String(lastGroup.group_id),
                                        appName
                                      );
                                    }
                                  }}
                                />
                                <span className="font-semibold">{appName}</span>
                              </label>

                              {selectedApps.includes(appName) && (
                                <RadioGroup
                                  name={appName + "-radio-group"}
                                  value={selectedGroups[appName]} // Only one group can be selected
                                  onValueChange={(value) =>
                                    toggleGroupSelection(value, appName)
                                  }
                                >
                                  {appGroupList.map((group, ind) => (
                                    <div
                                      key={ind}
                                      className="ml-4 flex items-center space-x-2"
                                    >
                                      <RadioGroupItem
                                        id={String(group.group_id)}
                                        value={String(group.group_id)}
                                      />
                                      <label
                                        htmlFor={String(group.group_id)}
                                        className="!cursor-pointer"
                                      >
                                        {group.group_name}
                                      </label>
                                    </div>
                                  ))}
                                </RadioGroup>
                              )}
                            </div>
                          );
                        })}
                        <ScrollBar />
                      </ScrollArea>
                    </PopoverContent>
                  </Popover>
                )}
              </div>

              <div className="flex justify-end space-x-4 p-6">
                <Button
                  variant="outline"
                  onClick={() => setIsDialogOpen(false)}
                  className="h-[40px]"
                >
                  Cancel
                </Button>
                <Button
                  className="bg-[#181818] text-white h-[40px]"
                  onClick={handleCreateUser}
                  disabled={!isFormValid}
                >
                  Save & Close
                </Button>
              </div>
            </DialogContent>
          </section>
        )}
      </Dialog>

      {/* Edit User Dialog (Retained) */}

      {/* <Dialog open={isEditDialogOpen} onOpenChange={setIsEditDialogOpen}>
        <DialogContent className="max-w-2xl p-6">
          <DialogHeader>
            <DialogTitle className="text-xl font-semibold text-gray-700 bg-white">
              Edit User Details
            </DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 gap-4">
            <Input
              placeholder="Contact Name"
              className="p-3 border rounded-md"
            />
            <Input
              placeholder="Enter Phone"
              className="p-3 border rounded-md"
            />
            <Input
              placeholder="Enter Email"
              className="p-3 border rounded-md"
            />
            <Input
              placeholder="Enter Password"
              className="p-3 border rounded-md"
            />

            <select
              className="p-3 border rounded-md"
              onClick={fetchLicensesList} // Fetch licenses when dropdown is clicked
            >
              <option value="">Select License</option>
              {licenses.map((license) => (
                <option key={license.id} value={license.id}>
                  {license.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex justify-end space-x-4 mt-6">
            <Button
              variant="outline"
              onClick={() => setIsEditDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              className="bg-[#181818] text-white"
              onClick={() => setIsEditDialogOpen(false)}
            >
              Save & Close
            </Button>
          </div>
        </DialogContent>
      </Dialog> */}
      {isEditDialogOpen && <div className="fixed inset-0 bg-black/30 z-[50]" />}
      <EditUserDialog
        isOpen={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
        selectedUser={selectedUser}
        updateOnEdit={updateOnEdit}
        
      />
    </div>
  );
};

export default OrganizationUsers;
